import { useState, useEffect } from "react"
import { useNavigate } from "react-router-dom"
import { createClient } from "@supabase/supabase-js"
import CoorayAppBar from "../../shared/components/CoorayAppBar"
import { NavigationButtonType } from "../../shared/components/CoorayAppBar"
import UserRepository from "../../repository/UserRepository"
import { AnalyticsEvent } from "../../shared/analytics/AnalyticsEvent"
import { Helmet } from "react-helmet"
import FeedbackButton from "../../shared/components/feedback/FeedbackButton"
import FilterChipsContainer from "../../shared/components/FilterChipsContainer"
import { sendPageView } from "../../shared/utils/AnalyticsUtils"

const supabase = createClient('https://twblyxzvdbhlhxxurpno.supabase.co', 'eeyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InR3Ymx5eHp2ZGJobGh4eHVycG5vIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjAzNDMzNTMsImV4cCI6MjA3NTkxOTM1M30.cOz8DeHN7L00i3VN2wF5NXs2quw95Eaz3-8IQs4ltgw')

export default function EditProfileInterestsPage({analytics}) {

    const [loadingText, setLoadingText] = useState(null)
    const [userProfile, setUserProfile] = useState(null)
    const [enabledFilters, setEnabledFilters] = useState([])
    const navigate = useNavigate()
    const filters = {
        "nonFood": [
            {
            "tag": "art_creativity",
            "cleanLabel": "Art & Creativity",
            "displayLabel": "🎨 Art & Creativity"
            },
            {
            "tag": "date_night",
            "cleanLabel": "Date Night",
            "displayLabel": "💕 Date Night"
            },
            {
            "tag": "dog_friendly",
            "cleanLabel": "Dog Friendly",
            "displayLabel": "🐶 Dog Friendly"
            },
            {
            "tag": "hidden_gems",
            "cleanLabel": "Hidden Gems",
            "displayLabel": "🔍 Hidden Gems"
            },
            {
            "tag": "historic_cultural",
            "cleanLabel": "Historic & Cultural",
            "displayLabel": "🏛️ Historic & Cultural"
            },
            {
            "tag": "kid_friendly",
            "cleanLabel": "Kid Friendly",
            "displayLabel": "👶🏻 Kid Friendly"
            },
            {
            "tag": "live_music",
            "cleanLabel": "Live Music & Entertainment",
            "displayLabel": "🎶 Live Music & Entertainment"
            },
            {
            "tag": "outdoor",
            "cleanLabel": "Outdoor",
            "displayLabel": "🌿 Outdoor"
            },
            {
            "tag": "scenic",
            "cleanLabel": "Scenic",
            "displayLabel": "🌅 Scenic"
            },
            {
            "tag": "shopping_markets",
            "cleanLabel": "Shopping & Markets",
            "displayLabel": "🛍️ Shopping & Markets"
            },
            {
            "tag": "wellness_relaxation",
            "cleanLabel": "Wellness & Relaxation",
            "displayLabel": "🧘 Wellness & Relaxation"
            }
        ],
        "food": [
            {
            "tag": "bakery",
            "cleanLabel": "Bakery",
            "displayLabel": "🥐 Bakery"
            },
            {
            "tag": "brunch_spots",
            "cleanLabel": "Brunch Spots",
            "displayLabel": "🍳 Brunch Spots"
            },
            {
            "tag": "cafe",
            "cleanLabel": "Cafe",
            "displayLabel": "☕ Cafe"
            },
            {
            "tag": "cheap_eats",
            "cleanLabel": "Cheap Eats",
            "displayLabel": "💰 Cheap Eats"
            },
            {
            "tag": "cocktails",
            "cleanLabel": "Cocktails",
            "displayLabel": "🍸 Cocktails"
            },
            {
            "tag": "craft_beer",
            "cleanLabel": "Craft Beer",
            "displayLabel": "🍻 Craft Beer"
            },
            {
            "tag": "date_night",
            "cleanLabel": "Date Night",
            "displayLabel": "💕 Date Night"
            },
            {
            "tag": "desserts",
            "cleanLabel": "Desserts",
            "displayLabel": "🍰 Desserts"
            },
            {
            "tag": "dog_friendly",
            "cleanLabel": "Dog Friendly",
            "displayLabel": "🐶 Dog Friendly"
            },
            {
            "tag": "fine_dining",
            "cleanLabel": "Fine Dining",
            "displayLabel": "🍽️ Fine Dining"
            },
            {
            "tag": "halal",
            "cleanLabel": "Halal",
            "displayLabel": "🕌 Halal"
            },
            {
            "tag": "healthy",
            "cleanLabel": "Healthy",
            "displayLabel": "🥗 Healthy"
            },
            {
            "tag": "kid_friendly",
            "cleanLabel": "Kid Friendly",
            "displayLabel": "👶🏻 Kid Friendly"
            },
            {
            "tag": "late_night",
            "cleanLabel": "Late-Night Bites",
            "displayLabel": "🌙 Late-Night Bites"
            },
            {
            "tag": "scenic",
            "cleanLabel": "Scenic",
            "displayLabel": "🌅 Scenic"
            },
            {
            "tag": "street_food",
            "cleanLabel": "Street Food",
            "displayLabel": "🌮 Street Food"
            },
            {
            "tag": "vegetarian",
            "cleanLabel": "Vegetarian",
            "displayLabel": "🥕 Vegetarian"
            }
        ]
    }

    useEffect(() => {
  
        const userRepository = new UserRepository()
        async function getProfile() {
            setLoadingText("Loading ...")
            const {
              data: { user },
            } = await supabase.auth.getUser()
            if (user == null) {
              navigate("/login", {replace: true})
            } else {
              const response = await userRepository.getUserProfile()
              console.log(response)
              setUserProfile(response.user)
              setLoadingText(null)
              setEnabledFilters(response.user.interests)
            }
        }
        getProfile()

        sendPageView(analytics, AnalyticsEvent.OWN_PROFILE_VIEW, {})
      }, [])

    function onBackPressed() {
      navigate(-1)
    }

    function onFilterOptionToggled(clickedOption) {
        console.log(`filter option toggled ${JSON.stringify(clickedOption)}`)
        if (enabledFilters.includes(clickedOption.id)) {
            setEnabledFilters(enabledFilters.filter((option) => option != clickedOption.id))
        } else {
            setEnabledFilters(enabledFilters.concat([clickedOption.id]))
        }
    }

    async function onApplyClick() {
        console.log(`${enabledFilters}`)
        setLoadingText("Applying ...")
        const userRepository = new UserRepository()
        await userRepository.updateUserInterests(enabledFilters)
        setLoadingText(null)
    }

    return <div>
      <Helmet><title>{userProfile ? userProfile.name : "Profile"} | Roambear</title></Helmet>
        <CoorayAppBar 
        title={ "" }
        onBackPressed={onBackPressed}
        navigationType={NavigationButtonType.Close}
        />
        {
          userProfile && <div className="px-4 gap-y-2 flex flex-col pt-4">
            <div className="text-lg px-4 md:px-12 text-center w-full py-4">Hi, <span className="font-bold">{userProfile.name}</span>! Choose your cravings—we’ll find the spots. No Ouija board or endless Google searches needed. 🔮</div>
          </div>
        }
        {
          <div className="px-4">
            <FilterChipsContainer 
            key={"food"}
            title={null}
            filterOptions={filters["food"].map((filterOption) => {
                return {
                    label: filterOption.displayLabel,
                    id: filterOption.tag,
                    isSelected: enabledFilters.includes(filterOption.tag)
                }
            })}
            onFilterOptionClick={onFilterOptionToggled}
            />
          </div>
        }
        <div className="px-4 text-center pt-12">
          <button className="btn btn-success text-success-content mr-2" onClick={
                  () => {
                      onApplyClick()
                  }
                  } >Apply
          </button>
          <button className="btn btn-ghost" onClick={
                () => {
                  onBackPressed()
                }
              }>Close</button>
        </div>

        {loadingText &&
        <div className='w-full h-screen fixed top-0 flex flex-col items-center justify-center backdrop-blur-sm bg-base-100/30'>
            <div className="loading loading-infinity loading-lg"></div>
            <div className='font-normal text-base-content mt-2'>{loadingText}</div>
        </div>
        }
        {
          <FeedbackButton />
        }
    </div>
}